import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  setIsLoadingIntegrations: `${NAMESPACE}_INTEGRATIONS_IS_LOADING_INTEGRATIONS`,

  connectIntegration: `${NAMESPACE}_INTEGRATIONS_CONNECT_INTEGRATION`,
  setConnectionState: `${NAMESPACE}_INTEGRATIONS_SET_IS_CONNECTING_INTEGRATION`,
  clearIntegrationConnectState: `${NAMESPACE}_INTEGRATION_CONNECT_CLEAR_STATUS`,

  disableIntegration: `${NAMESPACE}_INTEGRATIONS_DISABLE_INTEGRATION`,
  setDisableState: `${NAMESPACE}_INTEGRATIONS_SET_DISABLE_STATE`,
  clearIntegrationDisableState: `${NAMESPACE}_INTEGRATION_DISABLE_CLEAR_STATUS`,
  updateEventNotifierSSEStatus: `${NAMESPACE}_INTEGRATIONS_UPDATE_EVENT_NOTIFIER_SSE_STATUS`,

  /** Integration actions */
  fetchIntegrations: `${NAMESPACE}_INTEGRATIONS_FETCH`,
  updateSingleIntegration: `${NAMESPACE}_INTEGRATIONS_UPDATE_SINGLE_INTEGRATION`,
  addIntegration: `${NAMESPACE}_INTEGRATIONS_ADD`,
  updateIntegrations: `${NAMESPACE}_INTEGRATIONS_UPDATE`,

  /** Logs actions */
  updateIntegrationLogs: `${NAMESPACE}_INTEGRATIONS_LOGS_UPDATE`,
  clearIntegrationLogs: `${NAMESPACE}_INTEGRATIONS_LOGS_CLEAR`,
  fetchIntegrationLogs: `${NAMESPACE}_INTEGRATIONS_LOGS_FETCH`,
  toggleRetryIntegrationLogsConfirmModal: `${NAMESPACE}_INTEGRATIONS_LOGS_TOGGLE_RETRY_CONFIRM_MODAL`,
  retryIntegrationLogs: `${NAMESPACE}_INTEGRATIONS_LOGS_RETRY`,
  setRetryLogsState: `${NAMESPACE}_INTEGRATIONS_LOGS_SET_RETRY_STATE`,

  toggleLogDetailsModal: `${NAMESPACE}_INTEGRATIONS_LOGS_TOGGLE_LOG_DETAILS_MODAL`,

  openRetriedLogsPage: `${NAMESPACE}_INTEGRATIONS_LOGS_OPEN_RETRIED_LOGS_PAGE`,
};

export const actionCreators = {
  setIsLoadingIntegrations: ({ isLoading }) => ({ type: actions.setIsLoadingIntegrations, payload: { isLoading } }),

  setConnectionState: (payload) => ({ type: actions.setConnectionState, payload }),
  connectIntegration: (payload) => ({ type: actions.connectIntegration, payload }),
  clearIntegrationConnectState: () => ({ type: actions.clearIntegrationConnectState }),

  disableIntegration: (payload) => ({ type: actions.disableIntegration, payload }),
  setDisableState: () => ({ type: actions.setDisableState }),
  clearIntegrationDisableState: () => ({ type: actions.clearIntegrationDisableState }),
  updateEventNotifierSSEStatus: (payload) => ({ type: actions.updateEventNotifierSSEStatus, payload }),

  /** Integration actions */
  fetchIntegrations: () => ({ type: actions.fetchIntegrations }),
  updateSingleIntegration: (payload) => ({ type: actions.updateSingleIntegration, payload }),
  addIntegration: (payload) => ({ type: actions.addIntegration, payload }),
  updateIntegrations: (payload) => ({ type: actions.updateIntegrations, payload }),

  /** Logs actions */
  updateIntegrationLogs: (payload) => ({ type: actions.updateIntegrationLogs, payload }),
  clearIntegrationLogs: () => ({ type: actions.clearIntegrationLogs }),
  fetchIntegrationLogs: (payload) => ({ type: actions.fetchIntegrationLogs, payload }),

  toggleRetryIntegrationLogsConfirmModal: () => ({ type: actions.toggleRetryIntegrationLogsConfirmModal }),
  retryIntegrationLogs: (payload) => ({ type: actions.retryIntegrationLogs, payload }),
  setRetryLogsState: (payload) => ({ type: actions.setRetryLogsState, payload }),

  toggleLogDetailsModal: (payload) => ({ type: actions.toggleLogDetailsModal, payload }),

  openRetriedLogsPage: (payload) => ({ type: actions.openRetriedLogsPage, payload }),
};

export default {
  actions,
  actionCreators
};
